import RootLayout from "./layouts/root-layout";
import Loader from "./app/common/loader";
import ScrollToTop from "./globals/scroll-to-top";
import { useEffect, useState } from "react";
import { AuthProvider } from "./context/AuthContext";
import { AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = window.setTimeout(() => {
      setLoading(false);
    }, 850);

    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  return (
    <AuthProvider>
      <AnimatePresence mode="wait">
        {isLoading && <Loader key={location.pathname} />}
      </AnimatePresence>
      <ScrollToTop />
      <RootLayout />
    </AuthProvider>
  )
}

export default App;
